import { AlertCircle, Wrench } from "lucide-react";

export function getSupportStatusColor(status: string): string {
  switch (status) {
    case "not_started":
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
    case "in_progress":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200";
    case "resolved":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200";
    case "closed":
      return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
  }
}

export function getSupportPriorityColor(priority: string): string {
  switch (priority) {
    case "low":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200";
    case "medium":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200";
    case "high":
      return "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200";
    case "urgent":
      return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
  }
}

export function getSupportTypeIcon(
  type: string,
  size: "sm" | "md" = "md",
): React.ReactNode {
  const cls =
    size === "sm"
      ? "h-3.5 w-3.5 shrink-0"
      : "h-4 w-4 shrink-0";
  return type === "complaint" ? (
    <AlertCircle className={`${cls} text-red-500`} />
  ) : (
    <Wrench className={`${cls} text-blue-500`} />
  );
}
